var userAgent = require('../../useragent');

/**
 * @param {string|Object|Event} event
 */
var Event = function(event) {
  /**
   * @type {boolean}
   */
  this.isCustomEvent = false;

  /**
   * The browser event object.
   * type {Event}
   */
  this.originalEvent = null;

  /**
   * Target that fired the event.
   * @type {Node}
   */
  this.target = null;

  /**
   * Event type.
   * @type {string}
   */
  this.type = '';

  /**
   * Event type.
   * @type {string}
   */
  this.forcedType = '';

  /**
   * Node that had the listener attached.
   * @type {Node|undefined}
   */
  this.currentTarget = null;

  /**
   * For mouseover and mouseout events, the related object for the event.
   * @type {Node}
   */
  this.relatedTarget = null;

  /**
   * X-coordinate relative to target.
   * @type {number}
   */
  this.offsetX = 0;

  /**
   * Y-coordinate relative to target.
   * @type {number}
   */
  this.offsetY = 0;

  /**
   * X-coordinate relative to the window.
   * @type {number}
   */
  this.clientX = 0;

  /**
   * Y-coordinate relative to the window.
   * @type {number}
   */
  this.clientY = 0;

  /**
   * X-coordinate relative to the monitor.
   * @type {number}
   */
  this.screenX = 0;

  /**
   * Y-coordinate relative to the monitor.
   * @type {number}
   */
  this.screenY = 0;

  /**
   * Which mouse button was pressed.
   * @type {number}
   */
  this.button = 0;

  /**
   * Keycode of key press.
   * @type {number}
   */
  this.keyCode = 0;

  /**
   * Keycode of key press.
   * @type {number}
   */
  this.charCode = 0;

  /**
   * Whether control was pressed at time of event.
   * @type {boolean}
   */
  this.ctrlKey = false;

  /**
   * Whether alt was pressed at time of event.
   * @type {boolean}
   */
  this.altKey = false;

  /**
   * Whether shift was pressed at time of event.
   * @type {boolean}
   */
  this.shiftKey = false;

  /**
   * Whether the meta key was pressed at time of event.
   * @type {boolean}
   */
  this.metaKey = false;

  /**
   * History state object, only set for PopState events where it's a copy of the
   * state object provided to pushState or replaceState.
   * @type {Object}
   */
  this.state = null;

  /**
   * Whether the default platform modifier key was pressed at time of event.
   * (This is control for all platforms except Mac, where it's Meta.)
   * @type {boolean}
   */
  this.platformModifierKey = false;

  this._init(event);
};

Event.prototype.hasForcedType = function() {
  return this.type !== this.forcedType;
};

Event.prototype.getType = function() {
  return this.forcedType || this.type;
};

Event.prototype._init = function init(e, opt_type) {
  // TODO(max.nikitin@): dirtyhack. `instanceof Event` doesnt work
  if (e.preventDefault) {
    var relevantTouch = e.changedTouches ? e.changedTouches[0] : null;

    this.originalEvent = e;
    this.type = e.type;
    this.target = /** @type {Node} */ (e.target) || e.srcElement;
    this.currentTarget = /** @type {Node} */ (e.currentTarget || e.target);

    var relatedTarget = /** @type {Node} */ (e.relatedTarget);
    if (!relatedTarget) {
      if (this.type.indexOf('mouseover') !== -1) {
        relatedTarget = e.fromElement;
      } else if (this.type.indexOf('mouseout') !== -1) {
        relatedTarget = e.toElement;
      }
    }

    this.relatedTarget = relatedTarget;

    if (relevantTouch != null) {
      this.clientX = relevantTouch.clientX !== undefined ? relevantTouch.clientX : relevantTouch.pageX;
      this.clientY = relevantTouch.clientY !== undefined ? relevantTouch.clientY : relevantTouch.pageY;
      this.screenX = relevantTouch.screenX || 0;
      this.screenY = relevantTouch.screenY || 0;
    } else {
      // Webkit emits a lame warning whenever layerX/layerY is accessed.
      // http://code.google.com/p/chromium/issues/detail?id=101733
      this.offsetX = e.offsetX !== undefined ? e.offsetX : e.layerX;
      this.offsetY = e.offsetY !== undefined ? e.offsetY : e.layerY;
      this.clientX = e.clientX !== undefined ? e.clientX : e.pageX;
      this.clientY = e.clientY !== undefined ? e.clientY : e.pageY;
      this.screenX = e.screenX || 0;
      this.screenY = e.screenY || 0;
    }

    this.button = e.button;
    this.keyCode = e.keyCode || 0;
    this.charCode = e.charCode || (this.type == 'keypress' ? e.keyCode : 0);
    this.ctrlKey = e.ctrlKey;
    this.altKey = e.altKey;
    this.shiftKey = e.shiftKey;
    this.metaKey = e.metaKey;
    this.platformModifierKey = userAgent.mac() ? e.metaKey : e.ctrlKey;
    this.state = e.state;
    this.isCustomEvent = false;
  } else if (typeof e === 'object') {
    if (e.type && e.event) {
      return init.call(this, e.event, e.type);
    }
    this.type = opt_type || e.type;
    this.target = e.target || null;
    this.currentTarget = e.currentTarget || e.target || null;
    this.relatedTarget = e.relatedTarget || null;
    this.isCustomEvent = true;
  } else if (typeof e === 'string') {
    this.type = e;
  } else {
    throw new Error('Bad data for event init: ' + e);
  }

  this.forcedType = opt_type || this.type;

  if (!this.type || typeof this.type !== 'string') {
    throw new Error('Bad event type: ' + this.type);
  }
}

module.exports = Event;


//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackaction/event.js
// module id = 24
// module chunks = 1 3